import React, { useState, useEffect } from 'react';
import styles from './referenceCheck.module.scss';
import { Card, Col, Container, Row, Image } from 'react-bootstrap';
import { getReferenceChecksCards } from '../../../services/util/referenceCheck';
import CSSLoader from '../../shared/cssLoader';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../customNavbar';
import { CustomButton } from '../../shared/customButton';
import ReactTooltip from 'react-tooltip';
import { CustomAlertBox } from '../../shared/customAlertBox';
import { CustomAvatarList } from '../../shared/customAvatarList';
import { CustomPreIcon } from '../../shared/customPreIcon';

const ReferenceCheck = (props) => {
    let concatValue;
    const [isLoading, setLoading] = useState(false);
    let [referenceCheckValues, setReferenceCheckValues] = useState([]);
    const breadcrumb = [
        {
            pathaddress: '/app/company/reference-checks',
            pathname: 'Reference Check',
            isActive: true,
            key: 1 + 'Reference Check'
        }
    ]

    const getAllReferenceChecks = async () => {
        setLoading(true)
        const values = await getReferenceChecksCards();
        if (values.success === true) {
            setReferenceCheckValues(values.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    function viewReferenceCheckDetails(step_id) {
        props.history.push({
            pathname: `/app/company/reference-checks/group`,
            search: `?step_id=${step_id}`
        });
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function truncateValue(value, maxLength) {
        return value.length > maxLength ? value.slice(0, maxLength - 1) + "…" : value;
    }

    // Company Settings Integration API call
    let [isURLLoading, setURLLoading] = useState(false);

    useEffect(() => {
        getAllReferenceChecks();
    }, []);

    useEffect(() => {
        let pageHit = '/app/company/reference-checks';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])


    return (
        <div>
            <Helmet>
                <title>Reference Check | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Row>
                                {
                                    (referenceCheckValues).map((values, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={index}>

                                            <Card className={styles.cardOuterBox}>
                                                <Card.Body >
                                                    <div className={styles.cardTitleBox}>
                                                        <CustomPreIcon
                                                            type="successIcon"
                                                            icon={
                                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g id="file-check-02">
                                                                        <path id="Icon" d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                </svg>
                                                            }
                                                        />
                                                        <div className={styles.cardTitleText}>
                                                            <p className={styles.cardTitlePrimaryText} data-tip data-for={values.pipeline_name + index} onChange={addMaxViewLength(values.pipeline_name, 80)}>{concatValue}</p>
                                                            {(values.pipeline_name).length > 80 &&
                                                                <ReactTooltip id={values.pipeline_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.pipeline_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                            <p className={styles.cardTitleSecondaryText}>
                                                                {truncateValue(values.hiring_position, 22)}
                                                                {" | "}
                                                                {truncateValue(values.step_name, 22)}
                                                            </p>

                                                            {(values.hiring_position).length > 22 &&
                                                                <ReactTooltip id={values.hiring_position + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.hiring_position}</span>
                                                                </ReactTooltip>
                                                            }
                                                            {(values.step_name).length > 22 &&
                                                                <ReactTooltip id={values.step_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.step_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr className={styles.horizontalDivider} />
                                                    <div className={styles.cardBodyText}>
                                                        <p >
                                                            {`${values.job_type === 10 ? "Full-Time" : values.job_type === 20 ? "Part-Time" : values.job_type === 30 ? "Contact / Temp" : values.job_type === 50 ? "Casual / Vacation" : ''}`}
                                                            {`${values.work_type === 10 ? " | Remote" : values.work_type === 20 ? " | On-site" : values.work_type === 30 ? " | Hybrid" : ''}`}
                                                            {`${values.location ? ` | ${values.location}` : ''}`}
                                                        </p>
                                                    </div>
                                                    <div className={styles.reviewDetails}>
                                                        <div>
                                                            <CustomAvatarList nameArray={values.top_candidate_name_list} totalUsers={values.candidate_count}></CustomAvatarList>
                                                        </div>
                                                        <div className={styles.cardBtn}>

                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Start Review"
                                                                type="secondaryBtn"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => viewReferenceCheckDetails(values.step_id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>


                                        </Col>
                                    ))

                                }
                                {/* {
                                    (referenceCheckValues).map((values, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={index}>
                                            <Card className={styles.cvReviewsCard}>
                                                <Card.Body className={styles.cardBody}>
                                                    <Row className="mb-2">
                                                        <Col>
                                                            <p className={styles.cardLabel}>Pipeline</p>
                                                            <p className={styles.cardValues} data-tip data-for={values.pipeline_name + index} onChange={addMaxViewLength(values.pipeline_name, 80)}>{concatValue}</p>
                                                            {(values.pipeline_name).length > 80 &&
                                                                <ReactTooltip id={values.pipeline_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.pipeline_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </Col>

                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col>
                                                            <p className={styles.cardLabel}>Position</p>
                                                            <p className={styles.cardValues} data-tip data-for={values.hiring_position + index} onChange={addMaxViewLength(values.hiring_position, 22)}>{concatValue}</p>
                                                            {(values.hiring_position).length > 22 &&
                                                                <ReactTooltip id={values.hiring_position + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.hiring_position}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </Col>


                                                        <Col>
                                                            <p className={styles.cardLabel}>Step</p>
                                                            <p className={styles.cardValues} data-tip data-for={values.step_name + index} onChange={addMaxViewLength(values.step_name, 22)}>{concatValue}</p>
                                                            {(values.step_name).length > 22 &&
                                                                <ReactTooltip id={values.step_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.step_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row className="align-items-center">
                                                        <Col sm={6} lg={4}>
                                                            <p className={styles.candidateCount}>{values.candidate_count}</p>
                                                        </Col>
                                                        <Col sm={6} lg={8}>
                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Start Review"
                                                                type="primaryActionBtn"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => viewReferenceCheckDetails(values.step_id)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))

                                } */}
                            </Row>
                        </Col>
                        <div className={styles.NoContainer}>
                            {
                                referenceCheckValues.length === 0 &&
                                (<div>
                                    <Col>
                                        <p className={styles.infoMessage}>Currently no Reference Check assigned to you to review. </p>
                                    </Col>
                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/cvReview.svg`} fluid />
                                    </Col>
                                </div>)
                            }
                        </div>
                    </div>

                </div>)
            }
        </div>
    )
}
export default ReferenceCheck;